// extracted by mini-css-extract-plugin
export var attachmentContainer = "_n4-0";
export var fileList = "_n4-2";
export var removeFileButton = "_n4-1";